import { GlobalLoading, Login, TopBar } from "@nxt-platform/global-components";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useSession } from "@descope/react-sdk";
import { usePageTitle } from "../features/page-title/pageTitle";
import { me } from "../i18n.ts";

export const Route = createFileRoute('/me')({
  component: RouteComponent,
})

function RouteComponent() {
  const t = me.useT();
  const { isAuthenticated, isSessionLoading } = useSession();
  usePageTitle(t("pageTitle.login"), undefined, !isSessionLoading && !isAuthenticated);

  if (isSessionLoading) return <GlobalLoading />;
  if (!isAuthenticated) return <Login />;

  return (
    <div className="h-dvh flex flex-col bg-linear-to-b from-gray-200 to-gray-50">
      <TopBar className="relative z-40" logo="tickaroo" />
      <Outlet />
    </div>
  );
}
